import styled from 'styled-components';

export const OprPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 100%;
`;

export const CustomHeaderContainer = styled.div`
  width: 100%;
`;

export const OpenReportingModalWrapper = styled.div`
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ModalWrapper = styled.div`
  width: 100%;
`;
